import { Component, inject } from '@angular/core';
import { MessageService } from '@corelabs/angular/messages';
import { MessageComponent } from './message/message.component';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.css'],

    imports: [MessageComponent],
})
export class MessagesComponent {
    private readonly messageService = inject(MessageService);

    readonly messages = this.messageService.messages;
}
